interface ErrorMessageComponentProps {
    errors: string[];
}

class ErrorMessageComponent extends React.Component<ErrorMessageComponentProps, never> {
    public render(): JSX.Element {
        let errorsToDisplay: JSX.Element[] = null;
        if (this.props.errors != null) {
            errorsToDisplay = this.props.errors.map((err, idx) => (
                <li key={"err" + idx}> {err}</li>
            ));
        }

        if (errorsToDisplay == null)
            return null;
        else
            return (
                <div className="error-message">
                    <ul>
                        {errorsToDisplay}
                    </ul>
                </div>
            );
    }
}

export { ErrorMessageComponent };
